<template>
  <div class="student_photo">
    <div class="student_photo_title">班级风采展示</div>
    <br>
    <p>东群教育，0000年00月00日成立发展壮大而来，目前公司以语言培训为核心，拥有短期培训系统、基础教育系统、文化传播系统、科技产业系统、咨询服务系统等多个发展平台，是一家集教育培训、教育产品研发、教育服务等于一体的大型综合性教育公司东群教育。东群教育于2019年0月0日在山东齐鲁交易所成功上市，成为山东上市的教育培训机构。</p>
    <img src="../img/item1-2.jpg">
  </div>
</template>

<script>
export default {};
</script>

<style>
.student_photo_title {
  font-size: 20px;
  border-bottom: 1px dotted #cccccc;
  color: #00ad74;
  line-height: 40px;
}
.student_photo p {
  font-size: 14px;
  font-weight: lighter;
  text-indent: 2em;
  line-height: 28px;
}
.student_photo img {
  align-items: center;
  display: flex;
  margin: 0 auto;
  width: 500px;
}
</style>
